import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const SectionCta = ({ to, children, testid }) => (
  <Link
    to={to}
    data-testid={testid}
    className="group inline-flex items-center gap-3 text-ink hover:text-brand-red transition-colors duration-500"
  >
    <span className="serif text-lg md:text-xl font-light border-b border-ink/30 group-hover:border-brand-red pb-1 transition-colors duration-500">
      {children}
    </span>
    <ArrowRight
      size={18}
      strokeWidth={1.4}
      className="shrink-0 group-hover:translate-x-1 transition-transform duration-500"
    />
  </Link>
);
